import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestAgencyTariffsMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  phone: Types.Scalars['String']['input'];
  site: Types.Scalars['String']['input'];
  inn: Types.Scalars['String']['input'];
  comment?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RequestAgencyTariffsMutationPage = { readonly __typename?: 'RootMutationType', readonly requestAgencyTariffs: boolean };


export const RequestAgencyTariffsDocument = gql`
    mutation RequestAgencyTariffs($name: String!, $phone: String!, $site: String!, $inn: String!, $comment: String) {
  requestAgencyTariffs(
    name: $name
    phone: $phone
    site: $site
    inn: $inn
    comment: $comment
  )
}
    `;
export type RequestAgencyTariffsMutationFn = Apollo.MutationFunction<RequestAgencyTariffsMutationPage, RequestAgencyTariffsMutationVariables>;

/**
 * __useRequestAgencyTariffsMutation__
 *
 * To run a mutation, you first call `useRequestAgencyTariffsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAgencyTariffsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAgencyTariffsMutation, { data, loading, error }] = useRequestAgencyTariffsMutation({
 *   variables: {
 *      name: // value for 'name'
 *      phone: // value for 'phone'
 *      site: // value for 'site'
 *      inn: // value for 'inn'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRequestAgencyTariffsMutation(baseOptions?: Apollo.MutationHookOptions<RequestAgencyTariffsMutationPage, RequestAgencyTariffsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAgencyTariffsMutationPage, RequestAgencyTariffsMutationVariables>(RequestAgencyTariffsDocument, options);
      }
export type RequestAgencyTariffsMutationHookResult = ReturnType<typeof useRequestAgencyTariffsMutation>;
export type RequestAgencyTariffsMutationResult = Apollo.MutationResult<RequestAgencyTariffsMutationPage>;
export type RequestAgencyTariffsMutationOptions = Apollo.BaseMutationOptions<RequestAgencyTariffsMutationPage, RequestAgencyTariffsMutationVariables>;